import { FC, ChangeEvent } from 'react';

interface Option {
    value: string;
    label: string;
    disabled?: boolean;
}

type SelectFilterProps = {
    id: string,
    value: any;
    label: string;
    onChange: (value: string) => void;
    defaultVoidOption?: boolean;
    defaultLabel?: string;
    options: Option[];
    className?: string;
    ariaLabel?: string;
}

const SelectFilter: FC<SelectFilterProps> = ({ id, value, label,
    onChange, className,
    defaultVoidOption, options,
    defaultLabel = "Todas...", ariaLabel }) => {

    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        onChange(event.target.value);
    };

    return (
        <div className={`relative ${className}`}>
            <select
                id={id}
                aria-label={ariaLabel}
                className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-white border border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-600 peer appearance-none pl-8 dark:text-white dark:bg-slate-800 dark:focus:border-blue-400"
                value={value}
                onChange={handleChange}
            >
                {defaultVoidOption && <option value="">{defaultLabel}</option>}
                {options.map((option) => (
                    <option key={option.value} value={option.value} disabled={option.disabled}>
                        {option.label}
                    </option>
                ))}
            </select>

            {/*
              whitespace-nowrap: o rótulo é absolute dentro de um container de largura fixa,
              então um label mais longo (ex.: "Recomendação PLD") quebrava em duas linhas,
              cobrindo o valor selecionado do select e deslocando o texto para baixo.
            */}
            <label htmlFor={id}
                className="absolute whitespace-nowrap text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 left-8 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:-translate-x-4 dark:text-white dark:bg-slate-800 dark:peer-focus:text-blue-400">
                {label}
            </label>
        </div>
    );
}

export default SelectFilter;